const TZ = "America/Denver";
const opts = { weekday: "short", month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" };

// Class times are set in Mountain Time; show MT, plus the student's local time when it differs.
export const formatClass = (iso) => {
  const d = new Date(iso);
  const mt = `${d.toLocaleString("en-US", { ...opts, timeZone: TZ })} MT`;
  const local = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (!local || local === TZ) return mt;
  const lt = d.toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit", timeZoneName: "short" });
  return `${mt} (${lt} your time)`;
};

export const COHORT_STATUS = { draft: "Draft (private)", open: "Published · Open for Enrollment", full: "Full", in_progress: "In Progress", completed: "Completed", canceled: "Canceled" };

// Faculty-led meeting time in the cohort's own time zone (e.g. "Tue, Nov 3, 2026, 7:00 PM MST").
export const formatIn = (iso, tz) => new Date(iso).toLocaleString("en-US", { ...opts, timeZone: tz || TZ, timeZoneName: "short" });
